<!-- 地图图例 -->
<template>
  <div class="map-legend">
    <!-- {{ mainStore.mapLegenf }} -->
    <!-- 流域概况 -->
    <div v-if="mainStore.legendType === 1" class="point">
      <p>
        <span class="text">水库</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水库.png') + ')'"></span>
      </p>
      <p>
        <span class="text">物联</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/物联.png') + ')'"></span>
      </p>
      <p>
        <span class="text">一体化</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/一体化_1类.png') + ')'"></span>
      </p>
      <p>
        <span class="text">国控</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/国控_1类.png') + ')'"></span>
      </p>
      <p>
        <span class="text">市控</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/市控_1类.png') + ')'"></span>
      </p>
      <p>
        <span class="text">区控</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/区控_1类.png') + ')'"></span>
      </p>
      <p>
        <span class="text">饮用水源地</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/饮用水源地.png') + ')'"></span>
      </p>
      <!-- <p >
        <span class="text">水文站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水文站.png') + ')'"
        ></span>
      </p>
      <p >
        <span class="text">水位站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水位站.png') + ')'"
        ></span>
      </p>
      <p >
        <span class="text">雨量站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨量站.png') + ')'"
        ></span>
      </p> -->
      <!-- <p >
        <span class="text">雨水排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨水排口.png') + ')'"
        ></span>
      </p>
      <p >
        <span class="text">污水排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/污水排口.png') + ')'"
        ></span>
      </p>
      <p v-show="legends.沿江排口">
        <span class="text">雨混排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨污排口.png') + ')'"
        ></span>
      </p> -->
      <p>
        <span class="text">河道视频监控</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/视频监控.png') + ')'"></span>
      </p>
      <p>
        <span class="text">工业企业</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/工业企业.png') + ')'"></span>
      </p>
      <p>
        <span class="text">水产养殖场</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水产养殖场.png') + ')'"></span>
      </p>
      <p>
        <span class="text">污水处理厂</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/污水厂.png') + ')'"></span>
      </p>
      <p>
        <span class="text">畜禽养殖场</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/畜禽养殖场.png') + ')'"></span>
      </p>
      <p>
        <span class="text">水文站</span><span class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水文站.png') + ')'"></span>
      </p>
      <p style="width: 160px"></p>
      <p><span class="text">Ⅰ类</span><span class="color" style="background: #5bcffb"></span></p>
      <p><span class="text">Ⅱ类</span><span class="color" style="background: #2288ff"></span></p>
      <p><span class="text">Ⅲ类</span><span class="color" style="background: #0efd85"></span></p>
      <p><span class="text">Ⅳ类</span><span class="color" style="background: #fcd617"></span></p>
      <p><span class="text">Ⅴ类</span><span class="color" style="background: #ff9700"></span></p>
      <p><span class="text">劣Ⅴ类</span><span class="color" style="background: #f81313"></span></p>
    </div>

    <div class="point">
      <div v-if="mainStore.legendType === 2" class="d-f mb20 ml30">
        <div class="vertical"></div>
        <div>
          <div>高：897</div>
          <div class="mt50">低：193</div>
        </div>
      </div>
      <div v-if="mainStore.legendType === 3">
        <!-- <p><span class="text">休耕</span><span class="color" style="background: #5b6e5d"></span></p>
        <p><span class="text">三季作物</span><span class="color" style="background: #bc17e6"></span></p>
        <p><span class="text">单季玉米</span><span class="color" style="background: #67f707"></span></p>
        <p><span class="text">单季水稻</span><span class="color" style="background: #e6211e"></span></p>
        <p><span class="text">单季其他</span><span class="color" style="background: #02f7b2"></span></p>
        <p><span class="text">其他双季作物</span><span class="color" style="background: #f29be7"></span></p>
        <p><span class="text">水稻+玉米</span><span class="color" style="background: #005ce6"></span></p>
        <p><span class="text">双季水稻</span><span class="color" style="background: #cbd90b"></span></p> -->
        <p><span class="text">休耕</span><span class="color" style="background: rgb(214,217,121)"></span></p>
        <p><span class="text">三季作物</span><span class="color" style="background: rgb(115,189,145)"></span></p>
        <p><span class="text">单季玉米</span><span class="color" style="background: rgb(189,219,164)"></span></p>
        <p><span class="text">单季水稻</span><span class="color" style="background: rgb(156,212,121)"></span></p>
        <p><span class="text">单季其他</span><span class="color" style="background: rgb(156,161,114)"></span></p>
        <p><span class="text">其他双季作物</span><span class="color" style="background: rgb(149,205,207)"></span></p>
        <p><span class="text">水稻+玉米</span><span class="color" style="background: rgb(87,156,92)"></span></p>
        <p><span class="text">双季水稻</span><span class="color" style="background: rgb(95,152,153)"></span></p>
      </div>
      <div v-if="mainStore.legendType === 4">
        <!-- <p><span class="text">耕地</span><span class="color" style="background: #3b3008"></span></p>
        <p><span class="text">林地</span><span class="color" style="background: #0622d6"></span></p>
        <p><span class="text">草地</span><span class="color" style="background: #25de04"></span></p>
        <p><span class="text">灌木地</span><span class="color" style="background: #3ff2ef"></span></p>
        <p><span class="text">水源地</span><span class="color" style="background: #f77ed1"></span></p>
        <p><span class="text">住宅区</span><span class="color" style="background: #fac61b"></span></p> -->
        <p><span class="text">耕地</span><span class="color" style="background: rgb(255,251,177)"></span></p>
        <p><span class="text">林地</span><span class="color" style="background: rgb(49,173,105)"></span></p>
        <p><span class="text">草地</span><span class="color" style="background: rgb(154,206,127)"></span></p>
        <p><span class="text">灌木地</span><span class="color" style="background: rgb(231,204,226)"></span></p>
        <p><span class="text">水源地</span><span class="color" style="background: rgb(163,214,245)"></span></p>
        <p><span class="text">住宅区</span><span class="color" style="background: rgb(220,100,120)"></span></p>
      </div>
      <div v-if="mainStore.legendType === 5">
        <p><span class="text">江河</span><span class="color" style="background: rgb(33,130,146)"></span></p>
        <p><span class="text">黄壤</span><span class="color" style="background: rgb(102,163,158)"></span></p>
        <p><span class="text">紫色土</span><span class="color" style="background: rgb(187,128,70)"></span></p>
        <p><span class="text">水稻土</span><span class="color" style="background: rgb(224,237,183)"></span></p>
        <p><span class="text">中性紫色土</span><span class="color" style="background: rgb(214,173,111)"></span></p>
        <p><span class="text">石灰性紫色土</span><span class="color" style="background: rgb(155,86,31)"></span></p>
        <p><span class="text">黄色石灰土</span><span class="color" style="background: rgb(242,228,165)"></span></p>
        <p><span class="text">漂洗水稻土</span><span class="color" style="background: rgb(161,200,173)"></span></p>
      </div>
    </div>
    <!-- 
    河长履职 - 一河一涨
    <div v-show="router.currentRoute.value.name == 'river_cheif_state'" class="point"></div>
      河长履职 - 河长巡河 
    <div v-show="router.currentRoute.value.name == 'river_cheif_patrol'" class="point">
      <p>
        <span class="text">巡河轨迹</span><span class="color" style="background: #ffee00"></span>
      </p>
      <p>
        <span class="text">在线巡河</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/在线巡河.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
      <p>
        <span class="text">起点</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/起点.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">终点</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/终点.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">重点监管</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/重点监管.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">巡查上报</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/超标报警.png') + ')'"
        ></span>
      </p>
    </div>
      河长履职 - 问题处置 
    <div v-show="router.currentRoute.value.name == 'problem_solving'" class="point">
      <p>
        <span class="text">巡查上报</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/超标报警.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
      <p>
        <span class="text">超标报警</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/视频告警.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
      <p>
        <span class="text">视频告警</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/公众投诉.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
      <p>
        <span class="text">公众投诉</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/巡查上报.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
      <p>
        <span class="text">其它</span
        ><span
          class="icon"
          :style="
            'background-image: url(' +
            require('@/assets/img/map/其它.png') +
            ');height: 30px;margin-bottom: 0px;'
          "
        ></span>
      </p>
    </div>
      河长履职 - 专项行动
    <div v-show="router.currentRoute.value.name == 'specific_project'" class="point">
      <p>
        <span class="text">专项行动</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/专项行动.png') + ')'"
        ></span>
      </p>
    </div>
      河库岸线管理 - 水功能区 
    <div v-show="router.currentRoute.value.name == 'functional_distribution'" class="gnq">
      <p><span class="text">保护区</span><span class="color" style="background: #19ff19"></span></p>
      <p><span class="text">保留区</span><span class="color" style="background: #0000ff"></span></p>
      <p>
        <span class="text">饮用水源区(饮用农业用水区)</span
        ><span class="color" style="background: #00ffff"></span>
      </p>
      <p>
        <span class="text">工业用水区</span><span class="color" style="background: #ff0000"></span>
      </p>
      <p>
        <span class="text">景观娱乐用水区</span
        ><span class="color" style="background: #7a9c11"></span>
      </p>
      <p>
        <span class="text">农业用水区(农业工业用水区)</span
        ><span class="color" style="background: #ffbf01"></span>
      </p>
      <p>
        <span class="text">排污控制区</span><span class="color" style="background: #ff06ff"></span>
      </p>
      <p><span class="text">过渡区</span><span class="color" style="background: #b95f5f"></span></p>
    </div>
      河库岸线管理 - 视频监控 
    <div v-show="router.currentRoute.value.name == 'river_bank_video'" class="point">
      <p>
        <span class="text">河道视频监控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/视频监控.png') + ')'"
        ></span>
      </p>
    </div>
      水环境水污染管理 - 手工监测断面
    <div v-show="router.currentRoute.value.name == 'manual_monitoring_section'" class="point">
      <p>
        <span class="text">国控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/国控_1类.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">市控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/市控_1类.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">区控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/区控_1类.png') + ')'"
        ></span>
      </p>
      <p style="width: 160px"></p>
      <p><span class="text">Ⅰ类</span><span class="color" style="background: #5bcffb"></span></p>
      <p><span class="text">Ⅱ类</span><span class="color" style="background: #2288ff"></span></p>
      <p><span class="text">Ⅲ类</span><span class="color" style="background: #0efd85"></span></p>
      <p><span class="text">Ⅳ类</span><span class="color" style="background: #fcd617"></span></p>
      <p><span class="text">Ⅴ类</span><span class="color" style="background: #ff9700"></span></p>
      <p><span class="text">劣Ⅴ类</span><span class="color" style="background: #f81313"></span></p>
    </div>
       水环境水污染管理 - 自动监测站 
    <div v-show="router.currentRoute.value.name == 'automonitoring_station'" class="point">
      <p>
        <span class="text">物联</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/物联.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">一体化</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/一体化_1类.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">国控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/国控_1类.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">市控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/市控_1类.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">区控</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/区控_1类.png') + ')'"
        ></span>
      </p>
      <p style="width: 160px"></p>
      <p><span class="text">Ⅰ类</span><span class="color" style="background: #5bcffb"></span></p>
      <p><span class="text">Ⅱ类</span><span class="color" style="background: #2288ff"></span></p>
      <p><span class="text">Ⅲ类</span><span class="color" style="background: #0efd85"></span></p>
      <p><span class="text">Ⅳ类</span><span class="color" style="background: #fcd617"></span></p>
      <p><span class="text">Ⅴ类</span><span class="color" style="background: #ff9700"></span></p>
      <p><span class="text">劣Ⅴ类</span><span class="color" style="background: #f81313"></span></p>
    </div>
      水环境水污染管理 - 工业污染源
    <div v-show="router.currentRoute.value.name == 'industrial_pollution_source'" class="point">
      <p>
        <span class="text">工业企业</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/工业企业.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">工业园区</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/工业园区.png') + ')'"
        ></span>
      </p>
    </div>
       水环境水污染管理 - 生活污染源 
    <div v-show="router.currentRoute.value.name == 'life_pollution_source'" class="point">
      <p>
        <span class="text">污水处理厂</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/污水厂.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">农贸市场</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/农贸市场.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">餐饮企业</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/餐饮企业.png') + ')'"
        ></span>
      </p>
    </div>
      水环境水污染管理 - 农业污染源 
    <div v-show="router.currentRoute.value.name == 'agriculture_pollution_source'" class="point">
      <p>
        <span class="text">畜牧养殖</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/畜禽养殖场.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">水产养殖场</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水产养殖场.png') + ')'"
        ></span>
      </p>
    </div>
     水环境水污染管理 - 沿江排口
    <div v-show="router.currentRoute.value.name == 'pollution_port'" class="point">
      <p>
        <span class="text">雨水排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨水排口.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">污水排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/污水排口.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">雨污排口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨污排口.png') + ')'"
        ></span>
      </p>
    </div>
    水资源管理 - 取水口
    <div v-show="router.currentRoute.value.name == 'intake'" class="point">
      <p>
        <span class="text">取水口</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/取水口.png') + ')'"
        ></span>
      </p>
    </div>
    水资源管理 - 饮用水源地
    <div v-show="router.currentRoute.value.name == 'water_source_place'" class="point">
      <p>
        <span class="text">饮用水源地</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/饮用水源地.png') + ')'"
        ></span>
      </p>
    </div>
   水资源管理 - 供水厂 
    <div v-show="router.currentRoute.value.name == 'water_supply_factory'" class="point">
      <p>
        <span class="text">供水厂</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水厂.png') + ')'"
        ></span>
      </p>
    </div>
   水资源管理 - 水利工程 
    <div v-show="router.currentRoute.value.name == 'water_consevancy_project'" class="point">
      <p>
        <span class="text">水库</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水库.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">闸坝</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/闸.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">堤防</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/堤防.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">引调提水</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/引调提水.png') + ')'"
        ></span>
      </p>
    </div>
    水资源管理 - 水文监测
    <div v-show="router.currentRoute.value.name == 'hydrology_monitoring'" class="point">
      <p>
        <span class="text">水文站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水文站.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">水位站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/水位站.png') + ')'"
        ></span>
      </p>
      <p>
        <span class="text">雨量站</span
        ><span
          class="icon"
          :style="'background-image: url(' + require('@/assets/img/map/雨量站.png') + ')'"
        ></span>
      </p>
    </div>
    -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { useRouter, onBeforeRouteUpdate } from 'vue-router'
import mapService from '@/utils/mapServices.js'
import Bus from '@/config/Bus'
import pinia from '@/store/index'
import { useMainStore } from '@/store/main'

const mainStore = useMainStore(pinia)
const router = useRouter()

const legends = ref({})

watch(
  () => router.currentRoute.value,
  (newValue, oldValue) => {
    legends.value = {}
  }
)

onMounted(() => {
  Bus.on('changeMapLegenf', (data) => {
    legends.value[data.type] = data.state
  })
})
</script>

<style lang="scss" scoped>
.map-legend {
  pointer-events: auto;
  position: absolute;
  bottom: 0px;
  z-index: 999;
  margin-right: 6px;

  .gnq {
    p {
      display: flex;
      align-items: center;
      margin: 6px 0px;
    }

    .text {
      font-size: 12px;
      line-height: 12px;
      display: inline-block;
      width: 90px;
    }

    .color {
      display: inline-block;
      width: 40px;
      height: 5px;
    }
  }

  .point {
    width: 160px;
    max-height: 232px;

    p {
      float: right;
      width: 80px;
      display: flex;
      align-items: center;
      margin: 0 0 2px 0;
    }

    .text {
      font-size: 12px;
      line-height: 12px;
      display: inline-block;
      width: 56px;
    }

    .icon {
      background-repeat: no-repeat;
      background-size: 100%;
      display: inline-block;
      width: 25px;
      height: 26px;
      margin-bottom: 4px;
    }

    .color {
      display: inline-block;
      margin: 10px 0;
      width: 25px;
      height: 5px;
    }

    .d-f {
      display: flex;
    }

    .mb20 {
      margin-bottom: 20px;
    }

    .ml30 {
      margin-left: 30px;
    }

    .mt50 {
      margin-top: 50px;
    }

    .vertical {
      width: 20px;
      height: 80px;
      //  background: linear-gradient(to bottom, #9dcc10, #e1f5ae);
      // background: linear-gradient(to bottom, #aff0da, #b0f5bd, #caf8b2, #fcfeb3, #8bcc5a, #22a329, #05843d);
      background: linear-gradient(to top, #C8FFC8 0%, #00E000 15%, #80FF00 25%, #FFFF00 40%, #FFA500 50%, #FF4500 60%, #8B4513 75%, #D3D3D3 100%);
      margin-right: 10px;
    }
  }
}
</style>
